export const DISCOVERY = {
  MOST_POPULAR_NB_STOCKS: 8,
};

export const MOCK_MODULR_VOP_NO_MATCH = 'MODULR_VOP_NO_MATCH';
export const MOCK_MODULR_VOP_CLOSE_MATCH = 'MODULR_VOP_CLOSE_MATCH';
export const MOCK_MODULR_VOP_CHECK_NOT_POSSIBLE = 'MODULR_VOP_CHECK_NOT_POSSIBLE';

export const PROFILE_INTERESTS_CATEGORIZED = {
  asset_classes: ['crypto', 'etfs', 'stocks', 'bonds', 'currencies', 'commodities'],
  investing_strategy: [
    'long-term-investing',
    'esg',
    'dividends',
    'growth-stocks',
    'value-investing',
    'short-term-investing',
    'auto-invest',
  ],
  markets: ['us', 'europe', 'china', 'asia', 'emerging'],
  sectors: [
    'automotive',
    'chemicals',
    'consumer-goods',
    'energy',
    'financial-services',
    'food-beverages',
    'healthcare',
    'industrial-goods',
    'leisure',
    'media',
    'metals-mining',
    'retail',
    'technology',
    'transportation',
    'utilities',
  ],
} as const;

export const PROFILE_INTERESTS = Object.values(PROFILE_INTERESTS_CATEGORIZED).flat();

export const PROFILE_INTERESTS_OMIT_IN_UK: (typeof PROFILE_INTERESTS)[number][] = ['crypto'];

export const SNOOZE_BO_TASK_MIN_DAYS = 1;
export const SNOOZE_BO_TASK_MAX_DAYS = 60;
export const SNOOZE_BO_TASK_DEFAULT_DAYS = 60;

// TBD
export const APP_MARKETING_MODALS_SCREENS = {
  TABS: ['Explore'],
  MAIN: ['CollectionDetails', 'CurrentInstrument'],
  CURRENT_PROFILE: ['NotificationSettings', 'PrivacySettings', 'Profile'],
  MODAL: ['InvestPlanCreationModal', 'ReferralsModal'],
};

export const BROADCAST_CHANNEL = {
  INSTRUMENT_STATUS_UPDATE: 1,
};

export const DEFAULT_MIN_ORDER_AMOUNT = 1_00;
export const STOCK_BUY_MIN_ORDER_AMOUNT = 2_00;
export const CRYPTO_BUY_MIN_ORDER_AMOUNT = 2_00;

export const KID_ARTICLE_SUPPORTED_COUNTRIES = [
  'UK',
  'BE',
  'PT',
  'DE',
  'IT',
  'LU',
  'NL',
  'PL',
  'FR',
] as const;

export const BO_LIST_MAX_RECORDS = 1000;

export const FLAT_FEE_VALUE = 1_00;
export const INVESTMENT_PLAN_FLAT_FEE_VALUE = 0;

export const MAX_FEE_FREE_CRYPTO_ORDER_AMOUNT = 250_00;

// Main reason for why we don't go below 12 months
// is because we have yearly execution schedule
export const SCHEDULE_STARTING_DATE_LIMIT_IN_MONTHS = 12;
export const SCHEDULE_STARTING_DATE_FIRST_EXECUTION_LIMIT_IN_DAYS = 10;

export const HIGH_VALUE_ORDER_LIMIT = 500_00;
export const HIGH_VALUE_ORDER_FEE_RATE = 0.002;

export const HIGH_VALUE_CRYPTO_LIMIT = 100_00;
export const HIGH_VALUE_CRYPTO_FEE_RATE = 0.01;

export const MAX_INSTRUMENT_SIDED_TRIGGERED_ORDERS = 5;
export const MAX_TRIGGERED_ORDERS = 100;

export const FR_INCOME_TAX_RATE = 0.3;
export const FR_SOCIAL_SECURITY_CONTRIBUTION_RATE = 0.186;
export const FR_DIVIDEND_INCOME_TAX_RATE = 0.128;

export const PUBLIC_TOKEN_IDENTIFIER_LENGTH = 32;

export const AMOUNT_REQUEST_MAX_AMOUNT_CENTS = 20_000_000_00;

// Investment Plans
export const WM_GIA_INVEST_PLAN_MIN_AMOUNT = 50_00;
export const WM_PEA_INVEST_PLAN_MIN_AMOUNT = 100_00;
export const WM_INVESTMENT_PLAN_NAME_MAX_LENGTH = 25;
export const WM_MANAGEMENT_FEE_RATE_MIN = 0;
export const WM_MANAGEMENT_FEE_RATE_MAX = 0.012;
export const WM_SUBSCRIPTION_FEE_RATE_MAX = 0.05;
export const WM_GIA_INVESTMENT_PLAN_MIN_INITIAL_AMOUNT = 50_00;
export const WM_PEA_INVESTMENT_PLAN_MIN_INITIAL_AMOUNT = 100_00;
export const WM_INVESTMENT_PLAN_MAX_INITIAL_AMOUNT = 20_000_000_00;
export const WM_PER_MAX_SUBSCRIPTION_AGE = 78;
export const SEPA_DIRECT_DEBIT_MAX_AMOUNT_CENTS = 150_000_00;
export const BUSINESS_SEPA_DIRECT_DEBIT_MAX_AMOUNT_CENTS = 8_000_000_00;

export const PG_ENUM_DEPRECATED_PREFIX = 'deprecated_%';

export const MAX_ORDER_AMOUNT_CENTS = 1500000_00;
export const MAX_CRYPTO_ORDER_AMOUNT_CENTS = 100000_00;

export const FEE_DEDUCTION_THRESHOLD = 0.15;

export const MAX_ASYNC_FLOW_REFRESH_ENTRIES = 100;
